function Card() {
    return (
      <div className="card">
        <img src="https://http.cat/200.jpg" alt="200 cat" />
        <h1>React Card</h1>
        <h2>This was Part 1</h2>
      </div>
    );
}

export default Card;